// extracted by mini-css-extract-plugin
export var modal = "_s5-0";
export var table = "_s5-1";